import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(code) {
    const response = await api.fetch(`/api/v2/airbnb/addintegration/`, {
      method: 'POST',
      body: JSON.stringify({
        code: code,
      }),
    })
    return await handleResponse(response)
  }
}
